import Vue from 'vue';
import ConfirmationDialogProgrammatic from '@/components/confirmation-dialog-programmatic/confirmation-dialog-programmatic.vue';

export let confirmationDialogProgrammatic = {
    open(params: ConfirmationDialogConfig): Promise<any> {
        let message = '';

        if (typeof params === 'string') {
            message = params;
        }

        const defaultParam = {
            title: 'Are You Sure?',
            variant: 'primary',
            showCancel: false,
            showContinue: false,
            okText: 'OK',
            continueText: 'Continue',
            cancelText: 'Cancel',
            message: 'You have unsaved changes, if you continue those changes will be lost.',
        };

        const propsData = Object.assign(defaultParam, params);

        const vm = typeof window !== 'undefined' && (window as any).Vue ? (window as any).Vue : Vue;

        const confirmationDialogComponent = vm.extend(ConfirmationDialogProgrammatic);

        return new Promise(() => {
            const dialog = new confirmationDialogComponent({
                el: document.createElement('div'),
                propsData: { ...propsData },
            });
        });
    },
};

const plugin = {
    install(vue: any) {
        Vue.prototype.$confirm = confirmationDialogProgrammatic;
    },
};

type ColorModifiers = 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'light' | 'dark' | string;

export interface ConfirmationDialogConfig {
    title?: string;
    variant?: ColorModifiers;
    showCancel?: boolean;
    showContinue?: boolean;
    okText?: string;
    continueText?: string;
    cancelText?: string;
    message?: string;
    onOk?: () => void;
    onContinue?: () => void;
    onCancel?: () => void;
}

declare module 'vue/types/vue' {
    interface Vue {
        $confirm: typeof confirmationDialogProgrammatic;
    }
}

export default plugin;
